import LinedInput, {InputType} from "./LinedInput";
import maskDateInput from "../lib/maskDateInput";
import masks from "../constants/masks";
import React from "react";

type Props = React.ComponentProps<"input"> & {
    setValue: (s: string) => void;
    id: string;
    value: string;
    label: string;
    extraInfo?: string;
    validationMessage?: string[];
    showValidIcon?: boolean;
};

function DateOfBirthInput({setValue, ...rest}: Props, ref: React.ForwardedRef<HTMLInputElement>) {
    function handleChangeWithMask(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;
        setValue(maskDateInput(value));
    }

    return (
        <LinedInput
            {...rest}
            onChange={handleChangeWithMask}
            maxLength={masks.dateOfBirth.pattern.length}
            pattern={masks.dateOfBirth.regex}
            type={InputType.Text}
            ref={ref}
        />
    );
}

export default React.forwardRef<HTMLInputElement, Props>(DateOfBirthInput);
